export default __webpack_public_path__ + "static/media/organiation-graphic.7921f154.svg";